<template>
    <div style="background: rgb(244, 244, 244); min-height: 80vh">
        <div class="page-content">
            <div class="page-input">
                <Input search enter-button="查询" v-model="value" @on-search="_getQuery" placeholder="输入手机号或订单号" />
            </div>
            <div class="page-shop">
                <div class="page-left">
                    <div class="ald-hd "> <s></s>
                        <span>看了又看</span>
                    </div>
                    <div class="item" v-for="(item,index) in SalesShop" v-show="index < 4" :key="item.id"
                        @click="$router.push('/details/'+item.id)">
                        <img :src="item.front" alt="">
                        <p class="look_price">￥ {{item.price}}</p>
                    </div>
                </div>
                <div class="page-right">
                    <div class="head">
                        订单详细
                    </div>
                    <Empty :text="'暂无相关订单'" v-if="shopList.length == 0"></Empty>
                    <div v-else>
                        <div class="item" v-for="item in shopList" :key="item.id">
                            <img :src="item.goods_front" alt="GEEK" @click="$router.push('/details/'+item.goods_id)">
                            <div class="name" @click="$router.push('/details/'+item.goods_id)">{{item.goods_name}}</div>
                            <div class="price">￥ {{ item.unit_price }}</div>
                            <div class="norms" @click="$router.push('/details/'+item.goods_id)">{{ item.norms_name }}
                            </div>
                            <div class="num">× {{ item.count }}</div>
                            <div class="money">总价：￥ {{ item.money }}</div>
                            <div class="btn">
                                <Button shape="circle" type="success" style="margin-right:10px"
                                    @click="read(item)">查看{{ item.goods_category }}</Button>
                                <Button shape="circle" v-clipboard:copy="item.content" v-clipboard:success="onCopy"
                                    v-clipboard:error="onError" type="success">复制{{ item.goods_category }}</Button>
                                <Button shape="circle" type="primary" @click="remarks(item)"
                                    style="margin-left:10px">商家备注</Button>

                            </div>
                           
                            <span class="time">{{item.endTime}}</span>
                        </div>
                    </div>

                </div>
                <div style="clear:both"></div>
            </div>
        </div>
        <Modal v-model="show" title="订单内容" footer-hide>
            <div class="show-main">
                <p v-for="item in content" :key="item">{{item}}</p>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {
        getSalesShop,
        getQuery,
    } from "@/api/index";
    import cookie from "@/utils/store/cookie";

    export default {
        data() {
            return {
                SalesShop: [],
                value: "",
                shopList: [],
                content: [],
                show: false
            };
        },

        created() {
            this._getSalesShop()
            if (cookie.get('phone')) {
                this.value = cookie.get('phone')
                this._getQuery()
            }
        },


        methods: {
            // 查看卡密
            read(row) {
                this.content = row.content
                this.show = true
            },
            // 查询订单
            _getQuery() {
                this.$Message.loading({
                    content: '查询中...',
                    duration: 2
                });
                getQuery({
                    value: this.value,
                }).then((res) => {
                    this.shopList = res.data;
                });
            },
            // 商家备注
            remarks(row) {
                this.$Modal.info({
                    title: '商家备注',
                    content: row.remarks ? row.remarks : '暂无备注'
                });
            },
            onCopy(e) {
                this.$Message.success({
                    background: true,
                    content: '复制成功'
                });
            },
            onError(e) {
                this.$Message.error({
                    background: true,
                    content: '复制失败'
                });
            },
            // 获取销量商品
            _getSalesShop() {
                getSalesShop().then((res) => {
                    this.SalesShop = res.data.salesShop;
                });
            },
        },
    };
</script>

<style lang="less" scoped>
    @import "../../../../assets/css/clean.css";
    @deep: ~">>>";

    .page-content {
        overflow: hidden;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        max-width: 1230px;
        background: #ffffff;

        .page-input {
            width: 500px;
            margin: 0 auto;
            padding: 50px 0;
            text-align: center;
        }

        .page-shop {
            margin-bottom: 30px;

            .page-left {
                height: 100%;
                width: 200px;
                border-right: 1px solid #f2f2f2;
                float: left;
                min-height: 670px;

                .ald-hd {
                    position: relative;
                    height: 25px;
                    margin-top: 5px;
                    overflow: hidden;

                    s {
                        position: absolute;
                        top: 10px;
                        left: 30px;
                        width: 150px;
                        height: 0;
                        border-top: 1px #c9c9c9 dotted;
                        text-decoration: none;
                    }

                    span {
                        position: absolute;
                        color: #999;
                        text-align: center;
                        width: 65px;
                        top: 0;
                        left: 50%;
                        margin-left: -2em;
                        background-color: #fff;
                    }
                }

                .item {
                    margin-left: 30px;
                    width: 150px;
                    height: 150px;
                    margin-bottom: 10px;
                    position: relative;
                    cursor: pointer;

                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 5px;
                    }

                    .look_price {
                        width: 100%;
                        left: 0;
                        position: absolute;
                        font-family: Arial;
                        line-height: 30px;
                        background-color: rgba(214, 206, 206, 0.8);
                        bottom: 0;
                        text-align: center;
                    }
                }
            }

            .page-right {
                border: 1px solid #ececec;
                margin: 0 30px 0 250px;
                min-height: 670px;

                .item {
                    border-bottom: 1px solid #f1f1f1;
                    padding: 20px;
                    padding-bottom: 10px;
                    position: relative;

                    img {
                        display: inline-block;
                        width: 125px;
                        height: 125px;
                        cursor: pointer;
                        border-radius: 2px;
                    }

                    .name {
                        position: absolute;
                        top: 20px;
                        left: 170px;
                        color: #000000;
                        font-size: 16px;
                        font-weight: 600;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        width: 70%;
                        cursor: pointer;
                    }

                    .price {
                        position: absolute;
                        top: 20px;
                        right: 20px;
                        color: #000000;
                        font-size: 16px;
                    }

                    .norms {
                        position: absolute;
                        top: 48px;
                        left: 170px;
                        font-size: 16px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        width: 70%;
                        cursor: pointer;
                    }

                    .num {
                        position: absolute;
                        top: 48px;
                        right: 20px;
                        font-size: 16px;
                    }

                    .money {
                        position: absolute;
                         top: 75px;
                        color: #000000;

                        right: 20px;
                        font-size: 16px;
                    }

                    .btn {
                        position: absolute;
                        bottom: 20px;
                        left: 170px;
                        font-size: 16px;
                    }

                    .content {
                        width: 75%;
                        font-size: 16px;
                        color: red;
                    }

                    .time {
                        position: absolute;
                        top: 75px;
                        left: 170px;
                        font-size: 16px;
                    }
                }

                .head {
                    background: #f1f1f1;
                    height: 40px;
                    line-height: 40px;
                    font-size: 16px;
                    padding-left: 20px;
                }
            }
        }


    }

    /deep/.ivu-modal-body {
        padding: 0;

        .show-main {
            padding: 10px 5px 10px 20px;
            min-height: 20vh;
            max-height: 60vh;
            overflow-y: scroll;
        }

        .show-main::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 6px;
            /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
        }

        .show-main::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #b1b1b1;
            border-radius: 9px;
        }

        .show-main::-webkit-scrollbar-track {
            background-color: #ddd;
        }
    }
</style>